(function (app) {
    app.provider("insuranceAccountApi", [function () {
        this.$get = ["crmApiGateway", function (crmApiGateway) {
            var service = {};

            service.get = function (insuranceAccountId) {
                return crmApiGateway.get("/InsuranceAccounts/" + insuranceAccountId);
            };

            service.getInsuranceAccounts = function () {
                return crmApiGateway.getArray("/InsuranceAccounts");
            };

            service.getCaseInsuranceAccounts = function (caseId) {
                return crmApiGateway.getArray("/Cases/" + caseId + "/InsuranceAccounts");
            };

            service.getNotes = function (insuranceAccountId) {
                return crmApiGateway.getArray("/InsuranceAccounts/" + insuranceAccountId + "/Notes");
            };

            service.getInsuranceAccountNote = function (insuranceAccountId, noteId) {
                return crmApiGateway.get("/InsuranceAccounts/" + insuranceAccountId + "/Notes/" + noteId);
            };

            service.getAdvisors = function (insuranceAccountId) {
                return crmApiGateway.getArray("/InsuranceAccounts/" + insuranceAccountId + "/Advisors");
            };

            service.update = function (insuranceAccountId, insuranceAccount) {
                return crmApiGateway.put("/InsuranceAccounts/" + insuranceAccountId, insuranceAccount);
            };

            service.updateCarrier = function (insuranceAccountId, insuranceAccount) {
                return crmApiGateway.put("/InsuranceAccounts/" + insuranceAccountId + "/Carrier", insuranceAccount);
            };

            service.updateCarrierProduct = function (insuranceAccountId, insuranceAccount) {
                return crmApiGateway.put("/InsuranceAccounts/" + insuranceAccountId + "/CarrierProduct", insuranceAccount);
            };

            service.updatePlanType = function (insuranceAccountId, insuranceAccount) {
                return crmApiGateway.put("/InsuranceAccounts/" + insuranceAccountId + "/PlanType", insuranceAccount);
            };

            service.updateNote = function (insuranceAccountId, noteId, note) {
                return crmApiGateway.put("/InsuranceAccounts/" + insuranceAccountId + "/Notes/" + noteId, note);
            };

            service.addAdvisor = function (insuranceAccountId, advisorId) {
                return crmApiGateway.put("/InsuranceAccounts/" + insuranceAccountId + "/Advisors/" + advisorId);
            };

            service.addNote = function (insuranceAccountId, note) {
                return crmApiGateway.post("/InsuranceAccounts/" + insuranceAccountId + "/Notes", note);
            };

            service.delete = function (insuranceAccountId) {
                return crmApiGateway.delete("/InsuranceAccounts/" + insuranceAccountId);
            };

            service.removeNote = function (insuranceAccountId, noteId) {
                return crmApiGateway.delete("/InsuranceAccounts/" + insuranceAccountId + "/Notes/" + noteId);
            };

            service.removeAdvisor = function (insuranceAccountId, advisorId) {
                return crmApiGateway.delete("/InsuranceAccounts/" + insuranceAccountId + "/Advisors/" + advisorId);
            };

            return service;
        }];
    }]);
})(window.app); //jshint ignore:line